module.exports = __webpack_public_path__ + "static/img/anxunu04.4d9351ba.svg";